//
//
//
//
//
//
//
//
//
//
//
//

import colors from "vuetify/es5/util/colors";

//import PlotlyChart from "./PlotlyChart";
import VuePlotly from "@statnett/vue-plotly";
import { removeTraceByName, findTraceIndexByName } from "../utils/plotly";

import { Continuum } from "../CesHttpClient";
import { mapState } from "vuex";

const clone = require("lodash.clone");
const isEqual = require("lodash.isequal");
const clonedeep = require("lodash.clonedeep");

export default {
  props: {
    plannedLogData: {
      type: Continuum,
      default: null
    }
  },
  mounted: function() {
    this.initChart();
    this.addData();
    this.applyShowPlannedWell();
    setInterval(() => {
      this.cacheAxisRange();
    }, 2000);
  },
  data: function() {
    return {
      chart: {},
      axisRangeInitialized: false,
      lastAxisRange: {
        xaxisRange: [0, 0],
        yaxisRange: [0, 0]
      }
    };
  },
  methods: {
    initChart: function() {
      this.axisRangeInitialized = false;
      this.chart = {};
      this.chart = {
        uuid: "234",
        traces: [],
        layout: {
          autosize: true,
          margin: {
            l: 100, // 80
            r: 40, // 80
            t: 60, // 100
            b: 60, // 80
            pad: 0
          },
          paper_bgcolor: "white",
          plot_bgcolor: "white",
          dragmode: "pan",
          showlegend: true,
          legend: {
            x: 1.01,
            y: 0.5,
            font: {
              color: "black"
            }
          },
          xaxis: {
            title: "<b>UTM X</b>",
            titlefont: {
              color: "black"
            },
            showshowticklabels: true,
            tickfont: {
              color: "black"
            },
            grid: true,
            zeroline: true,
            showline: true,
            mirror: "ticks",
            gridcolor: colors.grey.darken2,
            zerolinecolor: colors.grey.darken2,
            linecolor: "black",
            linewidth: 2,
            side: "top"
          },
          yaxis: {
            title: "<b>UTM Y</b>",
            titlefont: {
              color: "black"
            },
            showshowticklabels: true,
            tickfont: {
              color: "black"
            },
            scaleanchor: "x",
            scaleratio: 1,
            autorange: true,
            showgrid: true,
            zeroline: true,
            showline: true,
            mirror: "ticks",
            gridcolor: colors.grey.darken2,
            zerolinecolor: colors.grey.darken2,
            linecolor: "black",
            linewidth: 2
          }
        },
        options: {
          useResizeHandler: true,
          responsive: true,
          displaylogo: false,
          autosizable: true,
          showTips: false,
          scrollZoom: true
        }
      };
      // if lastAxisRange cached, restore it
      if (!isEqual(this.lastAxisRange.xaxisRange, [0, 0])) {
        this.chart.layout.xaxis.range = clone(this.lastAxisRange.xaxisRange);
        //this.chart.layout.yaxis.range = clone(this.lastAxisRange.yaxisRange);
        this.chart.layout.xaxis.autorange = false;
        //this.chart.layout.yaxis.autorange = false;
        this.axisRangeInitialized = true;
      }
    },
    addData: function() {
      if (!this.logPlotData) {
        return;
      }

      const x = this.logPlotData["X"].d;
      const y = this.logPlotData["Y"].d;

      if (this.axisRangeInitialized == false) {
        this.chart.layout.xaxis.autorange = false;
        const xmin = x[0];
        const xmax = x[x.length - 1];
        const xdiff = xmax - xmin;
        this.chart.layout.xaxis.range = [xmin - xdiff, xmax + xdiff];

        // setup through yaxis scaleanchor to x, scaleratio equals to 1
        // this.chart.layout.yaxis.autorange = false;
        // const ymin = y[0];
        // const ymax = y[x.length - 1];
        // const ydiff = ymax - ymin;
        // this.chart.layout.yaxis.range = [ymin - ydiff, ymax + ydiff];

        this.axisRangeInitialized = true;
      }

      let traces = [];
      let trace = {
        _type: "wellpath",
        _trim: false,
        x: x,
        y: y,
        name: "Planned Path",
        line: {
          width: 2,
          dash: "dash",
          color: "black"
        }
      };
      traces.push(trace);

      if (this.currentMDindex) {
        let trace2 = {
          _type: "wellpath",
          _trim: true,
          _x: clonedeep(x),
          _y: clonedeep(y),
          x: x.slice(0, this.currentMDindex + 1),
          y: y.slice(0, this.currentMDindex + 1),
          name: "Drilled Path",
          opacity: 0.75,
          line: {
            width: 2,
            shape: "line",
            color: "red"
          }
        };
        traces.push(trace2);

        const traceDrillbit = this.getDrillbitTrace(x, y);
        traces.push(traceDrillbit);
      }

      this.chart.layout.datarevision = new Date().getTime();
      this.chart.traces = traces;
    },
    getDrillbitTrace: function(xOrig, yOrig) {
      const x = xOrig.slice(0, this.currentMDindex + 1);
      const y = yOrig.slice(0, this.currentMDindex + 1);
      if (!x || !y) return {};

      var trace4 = {
        _type: 'wellpathlabel',
        _key: 'drillbitpoint',
        _trim: true,
        _x: clonedeep(xOrig),
        _y: clonedeep(yOrig),
        x: [x[this.currentMDindex]],
        y: [y[this.currentMDindex]],
        type: 'scatter',
        mode: 'markers',
        marker: {
          color: 'green',
          size: 10
        },
        name: 'Drillbit'
      }
      return trace4;
    },
    cacheAxisRange: function() {
      this.lastAxisRange.xaxisRange = clone(this.chart.layout.xaxis.range);
      //this.lastAxisRange.yaxisRange = clone(this.chart.layout.yaxis.range);
      //console.log("current Axis Ranges = ");
      //console.log(JSON.stringify(this.lastAxisRange));
    },
    addPlannedWell: function() {
      if (
        !this.plannedLogData ||
        !this.plannedLogData.hasData("UTMx") ||
        !this.plannedLogData.hasData("UTMy")
      )
        return;
      // console.log("Plot planned well at map view");
      const x = this.plannedLogData.getData("UTMx");
      const y = this.plannedLogData.getData("UTMy");
      let trace = {
        x: x,
        y: y,
        name: "Planned Well",
        opacity: 0.5,
        line: {
          width: 2,
          shape: "line",
          color: "yellow"
        }
      };

      this.chart.traces.push(trace);
    },
    applyShowPlannedWell: function() {
      if (
        this.showPlannedWell && findTraceIndexByName(this.chart.traces, "Planned Well") == -1
      ) {
        this.addPlannedWell();
      }
      if (
        !this.showPlannedWell && findTraceIndexByName(this.chart.traces, "Planned Well") != -1
      ) {
        removeTraceByName(this.chart.traces, "Planned Well");
      }
    },
    trimChartByMd: function() {
      const traces = this.chart.traces;
      traces.forEach((trace, index, traces) => {
        if(trace.hasOwnProperty('_trim') && trace._trim) {
          // For 1D logs like wellpath & well log
          if(trace.hasOwnProperty('_type') && (trace._type == 'wellpath' || trace._type == 'welllog')) {
            traces[index].x = trace._x.slice(0, this.currentMDindex + 1);
            traces[index].y = trace._y.slice(0, this.currentMDindex + 1);
          }
          // For labels like drillbit
          if(trace.hasOwnProperty('_type') && (trace._type == 'wellpathlabel')) {
            const x = trace._x;
            const y = trace._y;
            traces[index].x = [x[this.currentMDindex]];
            traces[index].y = [y[this.currentMDindex]];
          }
        }
      })
    }
  },
  computed: {
    ...mapState({
      isPrintConsole: state => state.preferences.isPrintConsole,
      showPlannedWell: state => state.preferences.global.showPlannedWell,
      logPlotData: state => state.drilling.logPlotData,
      currentMDindex: state => state.drilling.currentMDindex,
      isDrillStep: state => state.drilling.isDrillStep,
    }),
  },
  watch: {
    logPlotData: function() {
      if(this.isPrintConsole)console.log("addData() triggered by logPlotData change.");
      this.addData();
      this.applyShowPlannedWell();
    },
    currentMDindex: function() {
      if (this.isDrillStep) {
        if(this.isPrintConsole)console.log("trimChartByMd() triggered by currentMDindex change.");
        this.trimChartByMd()
      } else {
        if(this.isPrintConsole)console.log("addData() triggered by currentMDindex change.");
        this.addData();
        this.applyShowPlannedWell();
      }
    },
    showPlannedWell: function() {
        this.applyShowPlannedWell();
    }
  },
  components: {
    VuePlotly
  }
};
